"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5914],{

/***/ 9138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ listing; },
  "U": function() { return /* binding */ levelToText; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./utils/dates.ts
var dates = __webpack_require__(4455);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(6665);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
;// CONCATENATED MODULE: ./comps/careers/positions/apply.tsx


var ApplyNow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
        text: "txt_apply_now"
    });
};
/* harmony default export */ var apply = (ApplyNow);

;// CONCATENATED MODULE: ./comps/careers/positions/listing.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  background-color: var(--color-background-cell);\n\n  .light &:hover {\n    background-color: var(--color-blue-50);\n  }\n\n  .dark &:hover {\n    background-color: var(--color-blue-50);\n  }\n\n  transition: background-color 200ms ease-in-out;\n\n  border-radius: 12px;\n\n  @media ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n\n    padding: 29px 30px;\n    border-radius: 0;\n\n    & + & {\n      border-top: 1px solid var(--color-separator);\n    }\n  }\n\n  @media ",
        " {\n    padding: 38px 30px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n  padding: 12px 24px;\n\n  @media ",
        " {\n    padding: 0;\n    gap: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  line-height: 36px;\n  color: var(--color-blue-800);\n\n  font-size: 18px;\n\n  text-align: center;\n\n  @media ",
        " {\n    text-align: left;\n    font-size: 20px;\n  }\n\n  @media ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 22px;\n\n  justify-content: center;\n\n  @media ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  width: 24px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n  align-items: center;\n\n  flex-shrink: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-blue-400);\n  text-transform: capitalize;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  svg *[fill="#828282"] {\n    stroke: var(--color-blue-400);\n    fill: var(--color-blue-400);\n  }\n'
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n\n  padding: 16px 21px;\n\n  @media ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: var(--color-blue-600);\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n\n  align-self: center;\n\n  @media ",
        " {\n    align-self: flex-end;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  background-color: var(--color-separator);\n\n  justify-self: stretch;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var Container = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-44ce414-0"
})(_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-1"
})(_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet);
var TitleContainer = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-44ce414-2"
})(_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var DetailRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-3"
})(_templateObject3(), breakpoints/* devices.tablet */.Hb.tablet);
var DetailIcon = (0,styled_components_browser_esm/* default */.ZP)(comps_image/* CustomThemedResource */.aK).withConfig({
    componentId: "sc-44ce414-4"
})(_templateObject4());
var DetailContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-5"
})(_templateObject5());
var DetailText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-44ce414-6"
})(_templateObject6(), breakpoints/* devices.desktop */.Hb.desktop);
var LevelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-7"
})(_templateObject7());
var InternIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.30078 20.5542H19.699",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.52495 8.90332H5.15624C4.68574 8.90332 4.30078 9.28828 4.30078 9.75878V17.1328C4.30078 17.6033 4.68574 17.9883 5.15624 17.9883H6.52495C6.99545 17.9883 7.3804 17.6033 7.3804 17.1328V9.75878C7.3804 9.28828 6.99545 8.90332 6.52495 8.90332Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6841 6.17432H11.3154C10.8449 6.17432 10.46 6.55927 10.46 7.02977V17.1327C10.46 17.6032 10.8449 17.9882 11.3154 17.9882H12.6841C13.1546 17.9882 13.5396 17.6032 13.5396 17.1327V7.02977C13.5396 6.55927 13.1546 6.17432 12.6841 6.17432Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.8433 3.44531H17.4746C17.0041 3.44531 16.6191 3.83027 16.6191 4.30077V17.1326C16.6191 17.6031 17.0041 17.9881 17.4746 17.9881H18.8433C19.3138 17.9881 19.6988 17.6031 19.6988 17.1326V4.30077C19.6988 3.83027 19.3138 3.44531 18.8433 3.44531Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var JuniorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.30103 20.5542H19.6992",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.52519 8.90332H5.15648C4.68598 8.90332 4.30103 9.28828 4.30103 9.75878V17.1328C4.30103 17.6033 4.68598 17.9883 5.15648 17.9883H6.52519C6.99569 17.9883 7.38065 17.6033 7.38065 17.1328V9.75878C7.38065 9.28828 6.99569 8.90332 6.52519 8.90332Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6844 6.17432H11.3157C10.8452 6.17432 10.4602 6.55927 10.4602 7.02977V17.1327C10.4602 17.6032 10.8452 17.9882 11.3157 17.9882H12.6844C13.1549 17.9882 13.5398 17.6032 13.5398 17.1327V7.02977C13.5398 6.55927 13.1549 6.17432 12.6844 6.17432Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.8438 3.44531H17.4751C17.0046 3.44531 16.6196 3.83027 16.6196 4.30077V17.1326C16.6196 17.6031 17.0046 17.9881 17.4751 17.9881H18.8438C19.3143 17.9881 19.6993 17.6031 19.6993 17.1326V4.30077C19.6993 3.83027 19.3143 3.44531 18.8438 3.44531Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var MiddleIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.30103 20.5542H19.6992",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.52519 8.90332H5.15648C4.68598 8.90332 4.30103 9.28828 4.30103 9.75878V17.1328C4.30103 17.6033 4.68598 17.9883 5.15648 17.9883H6.52519C6.99569 17.9883 7.38065 17.6033 7.38065 17.1328V9.75878C7.38065 9.28828 6.99569 8.90332 6.52519 8.90332Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6844 6.17432H11.3157C10.8452 6.17432 10.4602 6.55927 10.4602 7.02977V17.1327C10.4602 17.6032 10.8452 17.9882 11.3157 17.9882H12.6844C13.1549 17.9882 13.5398 17.6032 13.5398 17.1327V7.02977C13.5398 6.55927 13.1549 6.17432 12.6844 6.17432Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.8438 3.44531H17.4751C17.0046 3.44531 16.6196 3.83027 16.6196 4.30077V17.1326C16.6196 17.6031 17.0046 17.9881 17.4751 17.9881H18.8438C19.3143 17.9881 19.6993 17.6031 19.6993 17.1326V4.30077C19.6993 3.83027 19.3143 3.44531 18.8438 3.44531Z",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var SeniorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M4.30103 20.5542H19.6992",
                    stroke: "var(--color-blue-400)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M6.52519 8.90332H5.15648C4.68598 8.90332 4.30103 9.28828 4.30103 9.75878V17.1328C4.30103 17.6033 4.68598 17.9883 5.15648 17.9883H6.52519C6.99569 17.9883 7.38065 17.6033 7.38065 17.1328V9.75878C7.38065 9.28828 6.99569 8.90332 6.52519 8.90332Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12.6844 6.17432H11.3157C10.8452 6.17432 10.4602 6.55927 10.4602 7.02977V17.1327C10.4602 17.6032 10.8452 17.9882 11.3157 17.9882H12.6844C13.1549 17.9882 13.5398 17.6032 13.5398 17.1327V7.02977C13.5398 6.55927 13.1549 6.17432 12.6844 6.17432Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.8438 3.44531H17.4751C17.0046 3.44531 16.6196 3.83027 16.6196 4.30077V17.1326C16.6196 17.6031 17.0046 17.9881 17.4751 17.9881H18.8438C19.3143 17.9881 19.6993 17.6031 19.6993 17.1326V4.30077C19.6993 3.83027 19.3143 3.44531 18.8438 3.44531Z",
                    fill: "var(--color-blue-500)",
                    stroke: "var(--color-blue-500)",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
var levelToText = function(level) {
    if (level === "Intern") return "Internship";
    if (level === "Junior") return "Junior";
    if (level === "Mid") return "Middle";
    return "Senior";
};
var Level = function(props) {
    var level = props.level;
    var getIcon = function(name) {
        if (name === "Intern") return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternIcon, {});
        if (name === "Junior") return /*#__PURE__*/ (0,jsx_runtime.jsx)(JuniorIcon, {});
        if (name === "Mid") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleIcon, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeniorIcon, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailContainer, {
        children: [
            getIcon(level),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailText, {
                children: levelToText(level)
            })
        ]
    });
};
var ActionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-8"
})(_templateObject8(), breakpoints/* devices.tablet */.Hb.tablet);
var DeadlineText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-44ce414-9"
})(_templateObject9(), breakpoints/* devices.tablet */.Hb.tablet);
var Separator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-44ce414-10"
})(_templateObject10());
var Listing = function(props) {
    var _job = props.job, position = _job.position, location = _job.location, employment = _job.employment, deadline = _job.deadline, level = _job.level, slug = _job.slug;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: "/careers/" + slug,
        onClick: function() {
            return (0,index_esm/* logEvent */.Kz)((0,index_esm/* getAnalytics */.IH)(), "web_position_apply", {
                slug: slug,
                uid: userInfo.userId
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContainer, {
                        children: position
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Level, {
                                level: level
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailIcon, {
                                        source: "/comps/time",
                                        format: "svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailText, {
                                        children: t("page-careers:txt_employment_" + employment)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailIcon, {
                                        source: "/comps/location",
                                        format: "svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailText, {
                                        children: location
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(apply, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeadlineText, {
                        children: deadline ? t("fs_deadline", {
                            date: (0,dates/* getFormattedDate */.L0)(deadline)
                        }) : t("txt_no_deadline")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var listing = (Listing);


/***/ }),

/***/ 4717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ Body3; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "pN": function() { return /* binding */ Body2; },
/* harmony export */   "qx": function() { return /* binding */ Body4; },
/* harmony export */   "wo": function() { return /* binding */ Title1; }
/* harmony export */ });
/* unused harmony exports Heading1, Heading4, Heading5, Heading6, Title2, Body1, Body5, Caption, buttonStyle, tooltipStyle */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1156);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 32px;\n    line-height: 38px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 48px;\n    line-height: 57px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 26px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 33px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 44px;\n    line-height: 48px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 800;\n  font-size: 24px;\n  line-height: 29px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 26px;\n    line-height: 31px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 32px;\n    line-height: 52px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 36px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 32px;\n    line-height: 38px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 36px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 36px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media ",
        " {\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 150%;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 150%;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 150%;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 29px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.02em;\n  color: var(--color-blue-700);\n\n  @media ",
        " {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 27px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 31px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 26px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 25px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 25px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 26px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 25px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 25px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-transform: uppercase;\n\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 15px;\n  letter-spacing: 0.08em;\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 15px;\n    letter-spacing: 1.5px;\n  }\n\n  @media ",
        " {\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.02em;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-290c71f4-0"
})(_templateObject(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-290c71f4-1"
})(_templateObject1(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-290c71f4-2"
})(_templateObject2(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-290c71f4-3"
})(_templateObject3(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-290c71f4-4"
})(_templateObject4(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-290c71f4-5"
})(_templateObject5(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Title1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-6"
})(_templateObject6(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Title2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-7"
})(_templateObject7(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Body1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-8"
})(_templateObject8(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Body2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-9"
})(_templateObject9(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Body3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-10"
})(_templateObject10(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Body4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-11"
})(_templateObject11(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Body5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-12"
})(_templateObject12(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var Caption = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-290c71f4-13"
})(_templateObject13(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var buttonStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject14(), _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.tablet */ .Hb.tablet, _utils_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .devices.desktop */ .Hb.desktop);
var tooltipStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject15());


/***/ }),

/***/ 5914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Container": function() { return /* binding */ careers_Container; },
  "GlobalStyle": function() { return /* binding */ GlobalStyle; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/image.tsx + 1 modules
var comps_image = __webpack_require__(9612);
// EXTERNAL MODULE: ./comps/typography.tsx
var typography = __webpack_require__(4717);
// EXTERNAL MODULE: ./utils/breakpoints.tsx
var breakpoints = __webpack_require__(1156);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
;// CONCATENATED MODULE: ./comps/careers/benefits/point.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	& path {\n		fill: var(--color-success);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	list-style: none;\n\n	display: flex;\n	flex-direction: row;\n	align-items: center;\n	gap: 8px;\n\n	font-weight: 500;\n	font-size: 18px;\n	line-height: 31px;\n\n	@media ",
        " {\n		gap: 16px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var TickContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0879d0e-0"
})(_templateObject());
var Tick = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TickContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM13.8872 6.72647C14.2884 6.34694 14.306 5.71402 13.9265 5.3128C13.5469 4.91158 12.914 4.894 12.5128 5.27353L7.83903 9.69466L6.75926 8.43492C6.39983 8.0156 5.76853 7.96704 5.34921 8.32646C4.92988 8.68588 4.88132 9.31718 5.24074 9.73651L7.00401 11.7936C7.18214 12.0015 7.43767 12.1272 7.71102 12.1415C7.98436 12.1558 8.25162 12.0574 8.45046 11.8693L13.8872 6.72647Z",
                fill: "#08E69E"
            })
        })
    });
};
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-d0879d0e-1"
})(_templateObject1(), breakpoints/* devices.desktop */.Hb.desktop);
var Point = function(props) {
    var text = props.text;
    var t = (0,esm/* useTranslation */.$G)([
        "page-careers",
        "common"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tick, {}),
            t(text)
        ]
    });
};
/* harmony default export */ var point = (Point);

;// CONCATENATED MODULE: ./comps/careers/benefits/index.tsx

function benefits_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: var(--w-screen);\n"
    ]);
    benefits_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function benefits_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  width: var(--w-screen);\n  background-color: var(--color-background);\n\n  gap: 12px;\n  padding: 22px 0 46px 0;\n\n  @media ",
        " {\n    padding: 54px 0 40px 0;\n  }\n"
    ]);
    benefits_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 26px;\n  letter-spacing: 0.02em;\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 33px;\n    letter-spacing: 0.02em;\n  }\n\n  @media ",
        " {\n    font-weight: 800;\n    font-size: 44px;\n    line-height: 48px;\n    letter-spacing: 0.02em;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  padding: 0 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  width: var(--w-screen);\n\n  overflow: hidden;\n\n  height: 181px;\n\n  @media ",
        " {\n    height: 232px;\n  }\n\n  @media ",
        " {\n    height: 280px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    .light & {\n      background-image: url("',
        '");\n    }\n\n    .dark & {\n      background-image: url("',
        '");\n    }\n  '
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: var(--w-screen);\n\n  height: 181px;\n\n  @media ",
        " {\n    height: 232px;\n  }\n\n  @media ",
        " {\n    height: 280px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: unset;\n\n  position: absolute;\n  top: 0;\n\n  right: 0;\n  height: 181px;\n\n  @media ",
        " {\n    right: -300px;\n    height: 232px;\n  }\n\n  @media ",
        " {\n    right: -200px;\n    height: 280px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: var(--w-screen);\n\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 22px;\n\n  width: var(--w-screen);\n  padding-top: 32px;\n\n  @media ",
        " {\n    align-items: flex-start;\n    gap: 16px;\n\n    width: 728px;\n    padding-top: 39px;\n  }\n\n  @media ",
        " {\n    width: 975px;\n    padding-top: 47px;\n    gap: 24px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 800;\n  font-size: 16px;\n  line-height: 23px;\n  color: var(--color-blue-700);\n\n  align-items: center;\n\n  @media ",
        " {\n    text-align: left;\n\n    font-size: 26px;\n  }\n\n  @media ",
        " {\n    font-size: 30px;\n    line-height: 32px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  gap: 16px;\n\n  @media ",
        " {\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 30px;\n  }\n\n  @media ",
        " {\n    gap: 90px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  align-items: center;\n\n  gap: 16px;\n\n  @media ",
        " {\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}








var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-0"
})(benefits_templateObject());
var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-1"
})(benefits_templateObject1(), breakpoints/* devices.desktop */.Hb.desktop);
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-520e3a1c-2"
})(_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(typography/* Body2 */.pN).withConfig({
    componentId: "sc-520e3a1c-3"
})(_templateObject3());
var CoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-4"
})(_templateObject4(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var CoverImageBackground = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-5"
})(_templateObject6(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop, function(props) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), props.light, props.dark);
});
var CoverImageForeground = (0,styled_components_browser_esm/* default */.ZP)(comps_image/* CustomThemedResource */.aK).withConfig({
    componentId: "sc-520e3a1c-6"
})(_templateObject7(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var PointsAligner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-7"
})(_templateObject8());
var PointsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-8"
})(_templateObject9(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var PointsTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-520e3a1c-9"
})(_templateObject10(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var PointsRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-520e3a1c-10"
})(_templateObject11(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var PointsColumn = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-520e3a1c-11"
})(_templateObject12(), breakpoints/* devices.tablet */.Hb.tablet);
var Benefits = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "page-careers",
        "common"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: t("common:lbl_careers")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                        children: t("txt_careers_subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImageBackground, {
                        light: (0,cdn/* assetUrl */.p)("/comps/benefits-backgroud-light.svg"),
                        dark: (0,cdn/* assetUrl */.p)("/comps/benefits-backgroud-dark.svg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverImageForeground, {
                        source: "/comps/benefits-foreground",
                        format: "svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* DesktopOrTablet */.lS, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsAligner, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsTitle, {
                                        children: t("txt_our_benefit")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsRow, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsColumn, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_medical_insurance"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_salary_review"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_free_parking"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsColumn, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_fun_activities"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_flexible_schedule"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                                        text: "txt_stock_plan"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* Mobile */.ij, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsTitle, {
                            children: t("txt_our_benefit")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_medical_insurance"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_salary_review"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_free_parking"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsColumn, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_fun_activities"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_flexible_schedule"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(point, {
                                            text: "txt_stock_plan"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var benefits = (Benefits);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./comps/careers/positions/listing.tsx + 1 modules
var listing = __webpack_require__(9138);
;// CONCATENATED MODULE: ./comps/careers/positions/category.tsx

function category_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  align-self: stretch;\n\n  & + & {\n    padding-top: 12px;\n\n    @media ",
        " {\n      padding-top: 45px;\n    }\n\n    @media ",
        " {\n      padding-top: 70px;\n    }\n  }\n\n  @media ",
        " {\n    gap: 5px;\n  }\n"
    ]);
    category_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function category_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: block;\n\n    color: var(--color-blue-600);\n    text-transform: uppercase;\n    padding: 0 16px;\n\n    font-weight: 700;\n    line-height: 52px;\n\n    font-size: 20px;\n  }\n\n  @media ",
        " {\n    font-size: 24px;\n    color: var(--color-blue-600);\n  }\n\n  ::selection {\n    color: var(--color-blue-600);\n  }\n"
    ]);
    category_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function category_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  gap: 12px;\n\n  @media ",
        " {\n    border-radius: 12px;\n    gap: 0;\n  }\n\n  overflow: hidden;\n"
    ]);
    category_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var category_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9870b872-0"
})(category_templateObject(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop, breakpoints/* devices.desktop */.Hb.desktop);
var Name = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-9870b872-1"
})(category_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var Listings = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9870b872-2"
})(category_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet);
var Category = function(props) {
    var name = props.name, jobs = props.jobs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(category_Container, {
        id: name.toLowerCase(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breakpoints/* DesktopOrTablet */.lS, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Listings, {
                children: jobs.map(function(job, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listing/* default */.Z, {
                        job: job
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var category = (Category);

// EXTERNAL MODULE: ./utils/scrollto.ts
var scrollto = __webpack_require__(1634);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./comps/careers/positions/index.tsx


function positions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: var(--w-screen);\n  background-color: var(--color-background);\n"
    ]);
    positions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function positions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n  padding: 0 16px;\n  align-self: stretch;\n\n  @media ",
        " {\n    padding: unset;\n    align-self: unset;\n\n    width: 605px;\n  }\n\n  @media ",
        " {\n    width: 975px;\n  }\n"
    ]);
    positions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function positions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  padding: 64px 0 80px 0;\n\n  @media ",
        " {\n    padding: 36px 0 16px 0;\n  }\n\n  @media ",
        " {\n    padding: 30px 0 30px 0;\n  }\n"
    ]);
    positions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function positions_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n\n  gap: 16px;\n\n  padding: 16px;\n\n  background-color: var(--color-background);\n\n  overflow-x: scroll;\n\n  overscroll-behavior-x: none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    positions_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function positions_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          position: fixed;\n          top: 48px;\n          left: 0;\n        "
    ]);
    positions_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function positions_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          position: absolute;\n          top: 100px;\n          left: 0;\n        "
    ]);
    positions_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function positions_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  z-index: 50;\n\n  width: var(--w-screen);\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    positions_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function positions_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: var(--color-primary-500);\n          color: var(--color-white);\n        "
    ]);
    positions_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function positions_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: var(--color-blue-100);\n          color: var(--color-blue-600);\n        "
    ]);
    positions_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function positions_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n\n  padding: 10px 18px;\n\n  border-radius: 30px;\n\n  transition: background-color 200ms ease-in-out,\n    color 200ms ease-in-out;\n  ",
        ";\n"
    ]);
    positions_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}









var positions_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7a545ed-0"
})(positions_templateObject());
var Resizer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7a545ed-1"
})(positions_templateObject1(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var positions_Title = (0,styled_components_browser_esm/* default */.ZP)(typography/* Heading3 */.aC).withConfig({
    componentId: "sc-a7a545ed-2"
})(positions_templateObject2(), breakpoints/* devices.tablet */.Hb.tablet, breakpoints/* devices.desktop */.Hb.desktop);
var MobileDepartmentsScroller = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7a545ed-3"
})(positions_templateObject3());
var MobileDepartments = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a7a545ed-4"
})(positions_templateObject6(), function(props) {
    return props.fixed ? (0,styled_components_browser_esm/* css */.iv)(positions_templateObject4()) : (0,styled_components_browser_esm/* css */.iv)(positions_templateObject5());
}, breakpoints/* devices.tablet */.Hb.tablet);
var SingleDepartment = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a7a545ed-5"
})(positions_templateObject9(), function(props) {
    return props.active ? (0,styled_components_browser_esm/* css */.iv)(positions_templateObject7()) : (0,styled_components_browser_esm/* css */.iv)(positions_templateObject8());
});
var Positions = function(props) {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "page-careers"
    ]).t;
    var ref = (0,react.useState)(false), fixed = ref[0], setFixed = ref[1];
    var ref1 = (0,react.useState)(0), active = ref1[0], setActive = ref1[1];
    var departments = (0,react.useMemo)(function() {
        return props.jobs.reduce(function(acc, job) {
            if (acc[job.department] === undefined) {
                acc[job.department] = [];
            }
            acc[job.department].push(job);
            return acc;
        }, {});
    }, [
        props.jobs
    ]);
    var router = (0,next_router.useRouter)();
    var handleScroll = (0,react.useCallback)(function() {
        var becomeFixed = 782;
        var shouldBeFixed = window.scrollY >= becomeFixed;
        if (shouldBeFixed !== fixed) setFixed(shouldBeFixed);
        var minimumTop = 120;
        var departmentTops = Object.keys(departments).map(function(tag) {
            var ref;
            return (ref = document.getElementById(tag.toLowerCase())) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().top;
        });
        var activeDepartment = (departmentTops.length - 1 - departmentTops.reverse().findIndex(function(top) {
            return top && top <= minimumTop;
        })) % departmentTops.length;
        if (activeDepartment !== active) setActive(activeDepartment);
    }, [
        fixed,
        setFixed,
        departments,
        active
    ]);
    (0,react.useEffect)(function() {
        addEventListener("scroll", handleScroll);
        handleScroll();
        return function() {
            return removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(positions_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Resizer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(positions_Title, {
                    children: t("page-careers:txt_careers_heading")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDepartments, {
                    fixed: fixed,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDepartmentsScroller, {
                        children: Object.entries(departments).map(function(param, index) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), department = _param[0];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleDepartment, {
                                onClick: function() {
                                    (0,scrollto/* scrollToSection */.Q)(department.toLowerCase())();
                                },
                                active: active === index,
                                children: department
                            }, index);
                        })
                    })
                }),
                Object.entries(departments).map(function(param, index) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), department = _param[0], jobs = _param[1];
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(category, {
                        name: department,
                        jobs: jobs
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var positions = (Positions);

// EXTERNAL MODULE: ./comps/crisp.tsx + 1 modules
var crisp = __webpack_require__(9889);
// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
;// CONCATENATED MODULE: ./pages/careers/index.tsx


function careers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	html {\n		background: var(--color-background);\n	}\n"
    ]);
    careers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function careers_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: var(--w-screen);\n\n  overflow: hidden;\n"
    ]);
    careers_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var __N_SSP = true;
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(careers_templateObject());
var careers_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ea97b6a2-0"
})(careers_templateObject1());
var Career = function(props) {
    var t = (0,esm/* useTranslation */.$G)("page-careers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(careers_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("txt_careers_title"),
                description: t("txt_careers_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(crisp/* default */.Z, {
                page: "careers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {
                hideHiring: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(positions, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var careers = (Career);


/***/ })

}]);